export default "__VITE_ASSET__41f783e1__"